/* @flow */

import { getEventId } from '@e180/domain/lib/event/util';

import * as authenticationTypes from 'src/shared/app/authentication/action/base/authenticationActionTypes';
import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import * as types from 'src/shared/domain/event/action/eventActionTypes';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';

const initialState = {};

const _updateEventData = (state: Object, action: Object, key: string) => {
  const { eventId, result } = action;

  const event = state[eventId];

  return {
    ...state,
    [`${eventId}`]: {
      ...event,
      [key]: result,
    },
  };
};

const _updateGroupBraindateAvailableSlots = (state: Object, action: Object) =>
  _updateEventData(state, action, 'group_braindate_available_periods');

const _updateGroupBraindateSlotSuggestions = (state: Object, action: Object) =>
  _updateEventData(state, action, 'group_braindate_time_slots_suggestions');

const _patch = (state: Object, action: Object) =>
  patchEntities(state, action, 'events');

const _clean = (state: Object, action: Object) => {
  const { result: id } = action;

  return {
    ...state,
    [id]: null,
  };
};

const handleAuthSuccess = (state: Object, { event }: Object) => ({
  ...state,
  [getEventId(event)]: event,
});

export default createReducer(initialState, {
  [types.FETCH_GROUP_BRAINDATE_AVAILABLE_PERIODS_SUCCESS]: _updateGroupBraindateAvailableSlots,
  [types.FETCH_GROUP_BRAINDATE_TIME_SLOTS_SUGGESTIONS_SUCCESS]: _updateGroupBraindateSlotSuggestions,
  [entititesTypes.PATCH_ENTITIES]: _patch,
  [types.FETCH_PUBLIC_EVENT_SUCCESS]: _clean,
  [authenticationTypes.LOGIN_SUCCESS]: handleAuthSuccess,
  [authenticationTypes.CREATE_PASSWORD_SUCCESS]: handleAuthSuccess,
});
